import { isEqualCaseInsensitive } from '../../../../../shared/utils/isEqualCaseInsensitive';
import { UNITED_STATES } from '../constants/UnitedStates';
import { getStateNameForAbbreviation } from './getStateNameForAbbreviation';

export function getStateName(input: string) {
	const validatedName = UNITED_STATES.find((state) =>
		isEqualCaseInsensitive(state.name, input),
	)?.name;

	// If the input matches a valid name (eg "north carolina"), use that...
	if (validatedName) {
		return validatedName;
	}

	// ..otherwise, try to find the name for a matching abbreviation (eg. "NC")
	return getStateNameForAbbreviation(input);
}
